import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';


import {InputTextComponent} from './form-parts/form-items/input-text/input-text.component';
import {SelectComponent} from './form-parts/form-items/select/select.component';
import {InputNumberComponent} from './form-parts/form-items/input-number/input-number.component';
import {SelectTreeComponent} from './form-parts/form-items/select-tree/select-tree.component';
import {NotifConnexionComponent} from './form-parts/form-items/notif-connexion/notif-connexion.component';
import {
    InputTextGoogleAutocompleteComponent
} from './form-parts/form-items/input-text-google-autocomplete/input-text-google-autocomplete.component';
import {SelectNumberComponent} from './form-parts/form-items/select-number/select-number.component';
import {SwitchComponent} from './form-parts/form-items/switch/switch.component';
import {MatFileInputModule} from './form-parts/mat-file-input/mat-file-input.module';

const FORM_MODULE = [
    InputTextComponent,
    SelectComponent,
    InputNumberComponent,
    SelectTreeComponent,
    NotifConnexionComponent,
    InputTextGoogleAutocompleteComponent,
    SelectNumberComponent,
    SwitchComponent
];
const BASE_MODULES = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
];
const MATERIAL_MODULE = [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatToolbarModule,
    MatDividerModule,
    MatTableModule,
    MatTabsModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatStepperModule,
    CdkStepperModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatFileInputModule
];

@NgModule({
    exports: [
        ...BASE_MODULES,
        ...MATERIAL_MODULE,
        ...FORM_MODULE
    ],
    imports: [
    ...BASE_MODULES,
    ...MATERIAL_MODULE,
    RouterModule,
    ...FORM_MODULE
],
    providers: [
    ]
})
export class SharedModule {
}
